export enum InputParametersHierarchyLevel {
  GLOBAL = 'global',
  USER = 'user',
  MEETING_TEMPLATE_GLOBAL = 'meeting_template_global',
  MEETING_TEMPLATE_USER = 'meeting_template_user',
  EMAIL_TYPE_GLOBAL = 'email_type_global',
  EMAIL_TYPE_USER = 'email_type_user',
  DOCUMENT_TYPE_GLOBAL = 'document_type_global',
  DOCUMENT_TYPE_USER = 'document_type_user',
}

export interface GlobalInputParametersHierarchyId {
  level: InputParametersHierarchyLevel.GLOBAL
}

export interface UserLevelInputParametersHierarchyId {
  level: InputParametersHierarchyLevel.USER
  userId: string
}

export interface MeetingTemplateGlobalInputParametersHierarchyId {
  level: InputParametersHierarchyLevel.MEETING_TEMPLATE_GLOBAL
  meetingTemplateId: string
}

export interface MeetingTemplateUserLevelInputParametersHierarchyId {
  level: InputParametersHierarchyLevel.MEETING_TEMPLATE_USER
  meetingTemplateId: string
  userId: string
}

export interface EmailTypeGlobalInputParametersHierarchyId {
  level: InputParametersHierarchyLevel.EMAIL_TYPE_GLOBAL
  emailTypeId: string
}

export interface EmailTypeUserLevelInputParametersHierarchyId {
  level: InputParametersHierarchyLevel.EMAIL_TYPE_USER
  emailTypeId: string
  userId: string
}

export interface DocumentTypeGlobalInputParametersHierarchyId {
  level: InputParametersHierarchyLevel.DOCUMENT_TYPE_GLOBAL
  documentTypeId: string
}

export interface DocumentTypeUserLevelInputParametersHierarchyId {
  level: InputParametersHierarchyLevel.DOCUMENT_TYPE_USER
  documentTypeId: string
  userId: string
}

export type InputParametersHierarchyId =
  | GlobalInputParametersHierarchyId
  | UserLevelInputParametersHierarchyId
  | MeetingTemplateGlobalInputParametersHierarchyId
  | MeetingTemplateUserLevelInputParametersHierarchyId
  | EmailTypeGlobalInputParametersHierarchyId
  | EmailTypeUserLevelInputParametersHierarchyId
  | DocumentTypeGlobalInputParametersHierarchyId
  | DocumentTypeUserLevelInputParametersHierarchyId

export interface InputParametersHierarchyNodeValue {
  id: string
  hierarchyId: InputParametersHierarchyId
  active: boolean
  inputParameters: { [key: string]: any }
  updatedAt: string
}

export type InputParametersHierarchyNodeByPresets = { [presetId: string]: InputParametersHierarchyNodeValue }

export type TemplateReference = {
  id: string
  name: string
  description: string
}

export type InputParametersHierarchyNodeTemplateReference = {
  id: string
  hierarchyId: InputParametersHierarchyId
  active: boolean
  template: TemplateReference
  createdAt: string
  updatedAt: string
}

export type InputParametersHierarchyTemplateResolution = {
  default?: TemplateReference
  references: { [key in InputParametersHierarchyLevel]: InputParametersHierarchyNodeTemplateReference }
}
